import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  TextTitle,
  ValidatedFixedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { ValidatedLegacyCallToActionWithLanguage } from './validated-legacy-call-to-action-with-language';
import CallToActionImg from '../media/call-to-action.svg';

export const ValidatedLegacyCallToActionWithLanguageSection = ({
  callToAction, isDisplayPlusMMA, setNewCTACallback, isMultimediaAd, isMMAAutomatedCTAOptInEnabled, automatedCTAEnable, isBulk, onChange, ...rest
}) => {
  const i18n = useContext(I18nContext);
  const ctaValidationProps = useMemo(() => ({
    data: callToAction,
  }), [callToAction]);

  return (
    <ValidatedFixedPanel
      key="call-to-action"
      title={
        <TextTitle
          titleKey={_TL_('Call-to-action')}
          topicKey="pop_BA_PMAX_CallToAction"
          icon={CallToActionImg}
          iconAltText={i18n.getString(_TL_('"Call to action" panel\'s image'))}
        />
      }
      noOverflowHidden
      relativePosition
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      {...rest}
    >
      <ValidatedLegacyCallToActionWithLanguage
        validationProps={ctaValidationProps}
        isDisplayPlusMMA={isDisplayPlusMMA}
        isMultimediaAd={isMultimediaAd}
        isMMAAutomatedCTAOptInEnabled={isMMAAutomatedCTAOptInEnabled}
        automatedCTAEnable={automatedCTAEnable}
        i18n={i18n}
        onChange={onChange}
        isBulk={isBulk}
        setNewCTACallback={setNewCTACallback}
      />
    </ValidatedFixedPanel>
  );
};

ValidatedLegacyCallToActionWithLanguageSection.propTypes = {
  isMMAAutomatedCTAOptInEnabled: PropTypes.bool,
  isDisplayPlusMMA: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  automatedCTAEnable: PropTypes.bool,
  callToAction: PropTypes.shape({
    cta: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  isBulk: PropTypes.bool,
  setNewCTACallback: PropTypes.func,
};

ValidatedLegacyCallToActionWithLanguageSection.defaultProps = {
  isDisplayPlusMMA: false,
  isMMAAutomatedCTAOptInEnabled: false,
  isMultimediaAd: false,
  automatedCTAEnable: false,
  isBulk: false,
  setNewCTACallback: null,
};
